import React, { useEffect, useState } from 'react';
import {
  PDFDownloadLink,
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
  Link,
} from '@react-pdf/renderer';
import { Button } from '@chakra-ui/react';
import resumeForPdf from '../utils/resumeForPdf';
import { getOrder, getVoucher, getAppSettings } from '../api';

const styles = StyleSheet.create({
  page: {
    // backgroundColor: '#E4E4E4',
    // textAlign: 'center',
    // height: '100%',
    border: '0px solid red',
  },
  section: {
    margin: 10,
    padding: 10,
    // height: '100%',
    border: '0px solid green',
  },
  text: {
    margin: 3,
    padding: 3,
    fontSize: '14px',
  },
  link: {
    fontFamily: 'Lato',
    fontSize: 10,
    color: 'red',
    textDecoration: 'none',
    alignSelf: 'flex-end',
    justifySelf: 'flex-end',
  },
});

const MyDoc = ({ orderId, orderInfo }) => {
  if (!orderId || !orderInfo) return null;

  const qrCodeCanvas = document.querySelector('canvas');
  const qrCodeDataUri = qrCodeCanvas.toDataURL('image/jpg', 0.6);

  let createdAt;
  let selectedDate;
  let pranzoCena;
  const options = { weekday: 'long', month: 'long', day: 'numeric' };
  const optionsWithTime = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  createdAt = new Intl.DateTimeFormat('it', options).format(new Date(orderInfo.createdAt));
  if (orderInfo.selectedDate) {
    const _date = new Date(orderInfo.selectedDate);
    selectedDate = orderInfo.showLunchDinner
      ? new Intl.DateTimeFormat('it', options).format(_date)
      : new Intl.DateTimeFormat('it', optionsWithTime).format(_date);
    pranzoCena = _date.getHours() < 16 ? 'pranzo' : 'cena';
  }
  const email = orderInfo.email;
  // console.log('EMAIL', email);

  const imgUrl = `/images/${process.env.REACT_APP_PROJECT_ID}`;

  // console.log(imgUrl)
  // console.log(selectedDate, pranzoCena, orderInfo.showLunchDinner);
  return (
    <Document>
      <Page size='A4' style={styles.page}>
        <View style={styles.section}>
          <Text style={{ textAlign: 'center', fontSize: '18px', margin: 5 }}>Ordine {orderId}</Text>

          <Image style={{ width: '200px', margin: '10px auto' }} source={{ uri: qrCodeDataUri }} />

          <Text style={{ fontSize: '14px', textAlign: 'center', margin: 5 }}>
            Creato {createdAt}
          </Text>

          {selectedDate && (
            <Text style={{ fontSize: '14px', textAlign: 'center', margin: 5 }}>
              Valido per{' '}
              {orderInfo.showLunchDinner ? ` ${selectedDate} (${pranzoCena})` : selectedDate}
            </Text>
          )}
          <Text style={{ fontSize: '14px', textAlign: 'center', margin: 5 }}>
            Acquirente {email}
          </Text>

          {/* SPONSOR */}
          {/* <View
            style={{
              flexGrow: 0,
              flexDirection: 'row',
            }}
          >
            <Image style={{ width: '200px', margin: '10px auto' }} src={`${imgUrl}/sponsor/qr-farma-city.jpg`} />
            <Image style={{ width: '200px', margin: '10px auto' }} src={`${imgUrl}/sponsor/qr-icare.jpg`} />
          </View> */}

          <Text style={{ fontSize: '16px', margin: 5 }}>Dettagli ordine</Text>
          {orderInfo.resumeForPdf.map((item, index) => {
            const free = item.free ? `+ ${item.free}` : '';
            return (
              <Text key={index} style={styles.text}>
                {item.quantity} {free} - {item.title} ({item.totalPrice} €)
              </Text>
            );
          })}

          <Text style={styles.text}>
            Totale:{' '}
            {orderInfo.resumeForPdf.reduce((sum, item) => {
              return (sum += item.totalPrice);
            }, 0)}{' '}
            €
          </Text>
          {orderInfo.voucherInfo && (
            <Text style={styles.text}>
              Voucher usati {orderInfo.voucherInfo.value}
              {orderInfo.voucherInfo.type === 'euro' ? ' €' : '%'}
            </Text>
          )}
        </View>

        {/* SPONSOR */}
        <View
          style={{
            // flexGrow: 0,
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          {/* <Image style={{ width: '200px', margin: '10px auto' }} src='/images/sponsor.jpg' /> */}
          <Image
            style={{ width: '200px', marginRight: '30px' }}
            src={`${imgUrl}/sponsor/qr-left.jpg`}
          />
          <Image
            style={{ width: '130px', height: '130px', marginLeft: '30px' }}
            src={`${imgUrl}/sponsor/qr-right.jpg`}
          />
        </View>

        <View
          style={{
            bottom: 5,
            left: '50%',
            // height: 24,
            position: 'absolute',
          }}
        >
          <Image
            style={{ width: '120px', position: 'relative', left: '-20%' }}
            src='/images/logo-black.png'
          />
          {/* <Link
            src='https://popular-pagamenti.web.app/promo.html'
            style={{
              fontSize: 12,
              position: 'relative',
              left: '-50%',
              color: 'blue',
            }}
          >
            <Text style={{ fontSize: 12, position: 'relative', left: '-50%', color: 'blue' }}>
              https://popular-pagamenti.web.app/promo.html
            </Text>
          </Link> */}

          <Text style={{ fontSize: 12, position: 'relative', left: '-53%', color: 'blue' }}>
            Promuovi Popular ad un evento e vinci un premio!
          </Text>

          {/* <Text style={{ fontSize: 12, position: 'relative', left: '-50%', color: 'blue' }}>
            https://popular-pagamenti.web.app/promo.html
          </Text> */}
          <Link
            src='https://popular-pagamenti.web.app/promo.html'
            style={{
              fontSize: 12,
              position: 'relative',
              left: '-50%',
              color: 'blue',
            }}
          >
            <Text>
              https://popular-pagamenti.web.app/promo.html
            </Text>
          </Link>
          {/* <Text style={{ fontSize: 12, position: 'relative', left: '-50%', color: 'blue' }}>
            Powered By Popular - https://popular-pagamenti.web.app
          </Text> */}
        </View>
      </Page>
    </Document>
  );
};

const DownloadPDF = ({ orderId }) => {
  const [orderInfo, setOrderInfo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const _getOrder = async (_orderId) => {
    setIsLoading(true);
    const o = await getOrder(_orderId);
    // o.voucher è il code del voucher
    if (o.voucher) {
      const res = await getVoucher(o.voucher);
      // IGNORA ERRORI res.success == false
      o.voucherInfo = res.data;
    }
    const { showLunchDinner } = await getAppSettings();
    o.showLunchDinner = showLunchDinner;
    setIsLoading(false);
    o.resumeForPdf = resumeForPdf(o.order);
    setOrderInfo(o);
  };

  useEffect(() => {
    if (!orderId) return;
    _getOrder(orderId);
  }, [orderId]);

  return (
    <div>
      <PDFDownloadLink
        document={<MyDoc orderId={orderId} orderInfo={orderInfo} />}
        fileName={`${process.env.REACT_APP_PROJECT_ID}-${orderId}.pdf`}
      >
        {/* eslint-disable-next-line no-unused-vars */}
        {({ blob, url, loading, error }) => {
          // pdr engine and order must be ready
          const isLoadingAll = loading || isLoading;
          return (
            <Button my={4} disabled={isLoadingAll}>
              {isLoadingAll ? 'Loading...' : 'Scarica'}
            </Button>
          );
        }}
      </PDFDownloadLink>
    </div>
  );
};

export default DownloadPDF;
